const setEmployee = function({ commit }, employee) {
    commit('SET_EMPLOYEE', employee)
}

export default {
    setEmployee,
}
